<main class="">
  <section class="bg-no-repeat bg-cover py-10 flex flex-col items-center"
    [style.background-image]="'url(' + (didCountryName | appSliders) + ')'">
    <div class="relative flex">
      <img [src]="packageCountryName | appFlags" [alt]="packageCountryName + ' flag'" class="absolute -left-9 top-0 w-12">
      <img [src]="didCountryName | appFlags" [alt]="didCountryName + ' flag'" class="w-12">
    </div>
    <h1 class="flex flex-col items-center text-white text-center leading-none pt-4">
      <span transloco="choose-number.title"></span>
      <span [transloco]="'markets-vn.' + didCountryName"></span>
    </h1>
  </section>

  <section class="px-6 smd:px-10">
    <p class="text-grey text-center pt-8 md:pt-16 smd:w-4/6 smd:mx-auto" transloco="choose-number.subtitle"></p>

    <h2 class="text-center py-8 md:py-16 font-semibold" transloco="choose-number.top-pick-plan.title"></h2>

    <div *ngIf="packageCountry" class="flex justify-center flex-wrap gap-5">
      <article class="flex flex-col items-center rounded-3xl shadow-full p-6 text-grey w-[320px]">
        <img src="/images/icons/plans/1vnumber.svg" alt="One virtual number feature" class="w-8 py-2">
        <p class="pt-4 text-center"
          [innerHTML]="'choose-number.top-pick-plan.card-1.'  + didCountryName + '-' + packageCountry?.packageId | transloco"></p>
        <div class="relative">
          <button type="button" (click)="showPeriodPopover()" class="cursor-pointer" aria-label="Show important advice">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="w-5 h-5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
            </svg>
          </button>
          <span *ngIf="showPopover" [innerHTML]="'choose-number.important-advice-' + didCountryName | transloco"
            class="absolute top-5 right-auto left-auto text-xs w-40 bg-gray-100 border border-gray-300 rounded shadow-lg p-2" role="status" aria-live="polite">
          </span>
        </div>
      </article>

      <article class="flex flex-col items-center rounded-3xl shadow-full p-6 text-grey w-[320px]">
        <img src="/images/icons/plans/2vnumber.svg" alt="Calling minutes feature" class="w-8 py-2">
        @if (packageCountry?.hasCallMinutes) {
          <p class="py-4 text-center"
          [innerHTML]="'choose-number.top-pick-plan.card-2.' + didCountryName + '-' + packageCountry?.packageId | transloco"></p>
        }@else {
          <p class="py-4 text-center"
          [innerHTML]="'choose-number.top-pick-plan.card-2.no-minutes' | transloco"></p>
        }
      </article>

      <article class="flex flex-col items-center rounded-3xl shadow-full p-6 text-grey w-[320px]">
        <img src="/images/icons/plans/3vnumber.svg" alt="Plan features" class="w-8 py-2">
        <p class="py-4 text-center" [innerHTML]="'choose-number.top-pick-plan.card-3-text' | transloco"></p>
      </article>

      <article *ngIf="packageCountry?.hasAccessNumber"
        class="flex flex-col items-center rounded-3xl shadow-full p-6 text-grey w-[320px]">
        <img src="/images/icons/plans/4vnumber.svg" alt="Access number feature" class="w-8 py-2">
        <p class="py-4 text-center" [innerHTML]="'choose-number.top-pick-plan.card-4-' + packageCountry?.packageId | transloco"></p>
      </article>
    </div>
  </section>

  <section class="px-5 smd:px-10">
    <article class="flex flex-col items-center py-16 w-72 mx-auto">
      @if (priceInteger) {
      <img src="/images/icons/personalInfo/shape2.svg" alt="" class="w-24 mr-auto">
      <div class="relative flex flex-col items-center space-x-2 w-[190px]" style="direction: ltr;">
        <span class="text-xl" transloco="choose-number.from">From</span>
        <!-- <div class="text-grey strikethrough text-2xl my-auto">$5<span class="text-base align-top">99</span></div> -->
        <div class="font-medium text-[4rem] leading-none">
          <span class="text-3xl align-middle">$</span>{{ priceInteger }}<span class="text-3xl align-top">{{ priceDecimal
            }}</span>
        </div>
        <div class="text-grey text-sm" transloco="choose-number.price"></div>
      </div>
      <img src="/images/icons/personalInfo/shape.svg" alt="" class="w-14 ml-auto">
      } @else {
      <app-spinner-small></app-spinner-small>
      }
    </article>
  </section>
  <!-- <p [innerHTML]="'choose-number.important-advice' | transloco" class="text center flex justify-center"></p> -->
  <section class="pb-16 px-5 smd:px-10 flex justify-center">
    <article
      class="relative flex flex-col items-center mlg:flex-row justify-center w-full max-w-[1360px] rounded-3xl shadow-full py-12 px-4 sm:px-8 mlg:ltr:mr-16 mlg:rtl:ml-16">
      <div class="flex flex-col sm:w-[150px] text-3xl font-bold pb-12 mb-auto leading-none"
        [innerHTML]="'choose-number.choose-number' | transloco"></div>
      <div
        class="flex flex-col items-center md:flex-row justify-evenly w-full mlg:w-[790px] gap-9 overflow-x-auto scrollbar-sec">
        @for (item of didNumbers; track $index) {
        <ul class="text-grey flex flex-col items-center gap-1 mb-auto pb-4">
          @if (shouldShowHeader(item, $index)) {
          <li class="font-semibold">{{ item.state }}</li>
          }@else {
          <li class="invisible">
            {{ item.state }}
          </li>
          }
          @for (did of item.dids; track $index) {
          <li class="flex gap-2 items-center">
            <span class="flex text-sm">+{{ did.did }}</span>
            <!-- <span class="text-sm pl-6 px-2">${{ did.price }}</span> -->
            <button type="button" (click)="onChooseVNumber(did)" class="text-orange cursor-pointer uppercase">
              <span transloco="choose-number.buy"></span>
            </button>
          </li>
          }
        </ul>
        }
      </div>

      <img src="/images/icons/plans/7vnumber.svg" alt=""
        class="w-40 mlg:absolute mlg:ltr:-right-16 mlg:rtl:-left-16 rtl:-scale-x-100 mlg:top-0 pt-16 mlg:pt-8">
    </article>
  </section>

  <section *ngIf="packageCountry" class="py-16 px-5">
    <h2 class="text-center pb-16 font-semibold" transloco="choose-number.need-more-info.title"></h2>
    <app-need-more-info-form [packageId]="packageCountry?.packageId.toString()" [packageIso]="packageCountry?.iso2"></app-need-more-info-form>
  </section>
</main>